import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from 'App';
import Wrapper from 'Wrapper';
import DetectDevice from 'components/DetectDevice';
import { createRoot } from 'react-dom/client';
import { pdfjs } from 'react-pdf';
import initSentry from 'sentryConfig';
import { registerSW } from 'virtual:pwa-register';
import './i18n';
import './index.css';

initSentry();

if (import.meta.env.DEV) {
  const module = await import('./mocks/browser');
  const worker = module.default;
  await worker.start({
    serviceWorker: {
      url: `http://localhost:5173/mockServiceWorker.js`,
    },
  });
}
const updateSW = registerSW({
  async onNeedRefresh() {
    // eslint-disable-next-line no-alert
    const shouldUpdate = window.confirm('A new version is available. Do you want to update?');
    if (shouldUpdate) {
      await updateSW();
    }
  },
});

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      gcTime: 1000 * 60 * 5,
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      staleTime: 1000 * 60 * 0.4,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
});

const container = document.querySelector('#root');
if (container) {
  const root = createRoot(container);
  root.render(
    // <StrictMode>
    <Wrapper>
      <QueryClientProvider client={queryClient}>
        <DetectDevice>
          <App />
        </DetectDevice>
      </QueryClientProvider>
    </Wrapper>,
    // {/* </StrictMode>, */}
  );
}
